type ToastVariantType = "default" | "default_with_icon" | "success" | "withAction" | "progress" | "avatar";
type ToastColors = "default" | "success" | "error" | "progress";

type ToastContentType = {
  toastTitle?: string;
  toastBody?: string;
  toastIcon?: string;
  toastActions?: string[];
};

let toastCount = 0;
const toastContainer = document.getElementById("toastContainer");

function toastTemplate(
  toastId: string,
  toastContent: ToastContentType,
  variant: ToastVariantType = "default",
  type: ToastColors = "default"
) {
  switch (variant) {
    case "default":
      return `<div class="mt-3 last:mb-4 hs-removing:-translate-y-5 hs-removing:opacity-0 transition duration-300 max-w-xs mx-auto bg-white border border-gray-200 rounded-xl shadow-lg dark:bg-neutral-800 dark:border-neutral-700" role="alert" tabindex="-1" aria-labelledby="toast-${toastId}-label">
      <div class="flex p-4">
        <div class="shrink-0">
          ${type === "success" ? `<svg class="shrink-0 size-4 text-teal-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path>
          </svg>` : type === "error" ? `<svg class="shrink-0 size-4 text-red-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
          </svg>` : type === "progress" ? `<svg class="shrink-0 size-4 text-yellow-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path>
          </svg>` : `<svg class="shrink-0 size-4 text-blue-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
          </svg>`}
        </div>
        <div class="ms-3">
          <p id="hs-toast-normal-example-label" class="text-sm text-gray-700 dark:text-neutral-400">
            ${toastContent.toastBody ?? ""}
          </p>
        </div>
      </div>
    </div>`;
    case "default_with_icon":
      return `<div class="mt-3 last:mb-4 hs-removing:-translate-y-5 hs-removing:opacity-0 transition duration-300 max-w-xs mx-auto bg-white border border-gray-200 rounded-xl shadow-lg dark:bg-neutral-800 dark:border-neutral-700" role="alert" tabindex="-1" aria-labelledby="toast-${toastId}-label">
        <div class="flex p-4">
          <div class="shrink-0">
            ${type === "success" ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#16A34A" stroke="#16A34A" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>` : type === "error" ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.73 18.0002L13.73 4.00022C13.5556 3.69243 13.3026 3.43641 12.9969 3.25829C12.6912 3.08017 12.3438 2.98633 11.99 2.98633C11.6362 2.98633 11.2888 3.08017 10.9831 3.25829C10.6774 3.43641 10.4244 3.69243 10.25 4.00022L2.25 18.0002C2.07368 18.3056 1.98123 18.6521 1.98201 19.0047C1.98279 19.3573 2.07678 19.7035 2.25444 20.008C2.43211 20.3126 2.68715 20.5648 2.99369 20.7391C3.30024 20.9133 3.64741 21.0034 4 21.0002H20C20.3509 20.9999 20.6955 20.9072 20.9993 20.7315C21.303 20.5558 21.5552 20.3033 21.7305 19.9993C21.9058 19.6954 21.998 19.3506 21.9979 18.9997C21.9979 18.6488 21.9054 18.3041 21.73 18.0002Z" fill="#DC2626" stroke="#DC2626" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 9V13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 17H12.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>` : type === "progress" ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2V6" stroke="#1E3A8A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.2 7.80039L19.1 4.90039" stroke="#1E40AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 12H22" stroke="#1D4ED8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.2 16.2002L19.1 19.1002" stroke="#2563EB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 18V22" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4.9 19.1002L7.8 16.2002" stroke="#60A5FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 12H6" stroke="#93C5FD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4.9 4.90039L7.8 7.80039" stroke="#BFDBFE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>` : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.268 21C10.4435 21.304 10.696 21.5565 11 21.732C11.3041 21.9075 11.6489 21.9999 12 21.9999C12.3511 21.9999 12.6959 21.9075 13 21.732C13.304 21.5565 13.5565 21.304 13.732 21" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.262 15.326C3.13137 15.4692 3.04516 15.6472 3.01386 15.8385C2.98256 16.0298 3.00752 16.226 3.08571 16.4034C3.1639 16.5807 3.29194 16.7316 3.45426 16.8375C3.61658 16.9434 3.80618 16.9999 4 17H20C20.1938 17.0001 20.3834 16.9438 20.5459 16.8381C20.7083 16.7324 20.8365 16.5817 20.9149 16.4045C20.9933 16.2273 21.0185 16.0311 20.9874 15.8398C20.9564 15.6485 20.8704 15.4703 20.74 15.327C19.41 13.956 18 12.499 18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 12.499 4.589 13.956 3.262 15.326Z" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`}
          </div>
          <div class="ms-4">
            <h3 id="toast-${toastId}-label" class="text-gray-800 font-semibold dark:text-white">
              App notifications
            </h3>
            <div class="mt-1 text-sm text-gray-600 dark:text-neutral-400 break-words">
               ${toastContent.toastBody ?? ""}
            </div>
            <!--<div class="mt-4">
              <div class="flex gap-x-3">
                <button type="button" class="text-blue-600 decoration-2 hover:underline font-medium text-sm focus:outline-none focus:underline dark:text-blue-500">
                  Don't allow
                </button>
                <button type="button" class="text-blue-600 decoration-2 hover:underline font-medium text-sm focus:outline-none focus:underline dark:text-blue-500">
                  Allow
                </button>
              </div>
            </div>-->
          </div>
        </div>
      </div>`;
    case "withAction":
      return `<div class="first:mt-3 last:mb-6 hs-removing:-translate-y-5 hs-removing:opacity-0 transition duration-300 max-w-xs mx-auto bg-white border border-gray-200 rounded-xl shadow-lg dark:bg-neutral-800 dark:border-neutral-700" role="alert" tabindex="-1"
      aria-labelledby="toast-${toastId}-label"
      id="toast-${toastId}">
        <div class="flex p-4">
          <div class="shrink-0">
          ${toastContent.toastIcon}
          </div>
        <div class= "ms-4" >
        <h3 id="toast-${toastId}-label" class="text-gray-800 font-semibold dark:text-white" >
          ${toastContent.toastTitle}
        </h3>
        <div class="mt-1 text-sm text-gray-600 dark:text-neutral-400" >
          Notifications may include alerts, sounds and icon badges.
            </div>
            <div div class="mt-4" >
              <div class="flex gap-x-3" >
                ${toastContent.toastActions
          ?.map((actionBtn) => actionBtn)
          ?.join("")}   
              </div>
            </div>
        </div>
      </div>`;
    case "progress":
      return `<div class="first:mt-3 last:mb-6 hs-removing:-translate-y-5 hs-removing:opacity-0 transition duration-300 max-w-xs mx-auto relative bg-white border border-gray-200 rounded-xl shadow-lg dark:bg-neutral-800 dark:border-neutral-700" role="alert" tabindex="-1" 
      aria-labelledby="toast-${toastId}-label"
      id="toast-${toastId}">
        <div class="flex gap-x-3 p-4">
          <div class="shrink-0">
            <!-- Icon -->
            <span class="m-1 inline-flex justify-center items-center size-8 rounded-full bg-gray-100 text-gray-800 dark:bg-neutral-700 dark:text-neutral-200">
              ${toastContent.toastIcon}
            </span>
            <!-- End Icon -->

            <button type="button" class="absolute top-3 end-3 inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-gray-800 opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100 dark:text-white" aria-label="Close"
            data-hs-remove-element="#toast-${toastId}">
              <span class="sr-only">Close</span>
              <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>

          <div class="grow me-5">
            <h3 id="toast-${toastId}-label" class="text-gray-800 font-medium text-sm dark:text-white">
              Uploading 3 files
            </h3>

            <!-- Progress -->
            <div class="mt-2 flex flex-col gap-x-3">
              <span class="block mb-1.5 text-xs text-gray-500 dark:text-neutral-400">57% · 5 seconds left</span>
              <div class="flex w-full h-1 bg-gray-200 rounded-full overflow-hidden dark:bg-neutral-700" role="progressbar" aria-valuenow="57" aria-valuemin="0" aria-valuemax="100">
                <div class="flex flex-col justify-center overflow-hidden bg-blue-600 text-xs text-white text-center whitespace-nowrap dark:bg-neutral-200" style="width: 57%"></div>
              </div>
            </div>
            <!-- End Progress -->
          </div>
        </div>
      </div>`;
    case "avatar":
      return `<div class="first:mt-3 last:mb-6 hs-removing:-translate-y-5 hs-removing:opacity-0 transition duration-300 max-w-xs mx-auto relative bg-white border border-gray-200 rounded-xl shadow-lg dark:bg-neutral-800 dark:border-neutral-700" role="alert" tabindex="-1" 
      aria-labelledby="toast-${toastId}-label"
      id="toast-${toastId}">
        <div class="flex p-4">
          <div class="shrink-0">
            ${toastContent.toastIcon}
            <button type="button" class="absolute top-3 end-3 inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-gray-800 opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100 dark:text-white" aria-label="Close"
            data-hs-remove-element="#toast-${toastId}">
              <span class="sr-only">Close</span>
              <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
          <div class="ms-4 me-5">
            <h3 id="toast-${toastId}-label" class="text-gray-800 font-medium text-sm dark:text-white">
              ${toastContent.toastTitle}
            </h3>
            <div class="mt-1 text-sm text-gray-600 dark:text-neutral-400">
              ${toastContent.toastBody}
            </div>
            <div class="mt-3">
              ${toastContent.toastActions?.map((actionBtn) => actionBtn)?.join("")}  
            </div>
          </div>
        </div>
      </div>`;
  }
}

export function addToast(
  toastContent: ToastContentType,
  variant: ToastVariantType = "default",
  type: ToastColors = "default",
  autoCloseTimeout: number = 300
) {
  if (!toastContainer) {
    console.error("Can't find Toast Container element on the page.");
    return;
  }

  if (!toastContent) {
    console.error("No toast content provided.");
    return;
  }

  toastCount++;
  const toastId = `toast-${toastCount}`;
  const newToast = toastTemplate(toastId, toastContent, variant, type);

  const tempDiv = document.createElement("div");
  if (newToast) tempDiv.innerHTML = newToast;
  else {
    console.error("Problem creating Toast from Template");
    return;
  }
  const toastElement = tempDiv.firstElementChild;

  if (toastElement) {
    toastContainer.appendChild(toastElement);
    window.HSStaticMethods.autoInit();

    // Auto-close the toast after 3 seconds with animation
    if (autoCloseTimeout) {
      setTimeout(() => {
        toastElement.classList.add("hs-removing");
        setTimeout(() => {
          toastElement.remove();
        }, 300); // Match this to the transition duration in the CSS (duration-300)
      }, 5000);
    }
  }
}
